// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CropContainer {\n}\n\n.CropImageInner {\n    width: 100%;\n    height: 100%;\n    border: 1px solid;\n}\n\n.react-draggable {\n    z-index: 5;\n}", ""]);
// Exports
module.exports = exports;
